import { parsePhoneNumberFromString } from "libphonenumber-js";

export const initializeValidationRules = (terms) => ({
    // Required Field
    required: (value) =>
        !!value || terms.validation_required_field,

    isNumber: (value) =>
        !isNaN(parseFloat(value)) || terms.validation_integer,

    isPositive: (value) =>
        parseFloat(value) > 0 || terms.validation_positive,

    // Quantity
    orderQuantity: (value) => {
        const val = parseInt(value);
        return (!isNaN(val) && val >= 0 && val <= 100) || terms.validation_invalid_quantity
    },

    // Email Format
    email: (value) =>
        /.+@.+\..+/.test(value) || terms.validation_format_email,

    // Boolean Required
    requiredBool: (value) =>
        value === true || terms.validation_required_field,

    // Phone Number Validation
    phone: (region) => (value) => {
        try {
            const phoneNumber = parsePhoneNumberFromString(value, region);
            if (phoneNumber && phoneNumber.isValid()) {
                return true;
            }
        } catch (error) {
            // Fallback to the error message
        }
        return terms.validation_format_phone;
    },

    // Bulstat Validation
    bulstat: (value) => {
        console.log(`Проверка на Булстат номер: ${value}`);

        // Булстат трябва да бъде само цифри и с дължина 9 или 13
        const bulstatRegex = /^\d{9}(\d{4})?$/;
        if (!bulstatRegex.test(value)) {
            return terms.validation_format_bulstat; // Невалиден формат
        }

        const digits = value.split("").map(Number);

        const validateChecksum = (digits) => {
            const weights = [1, 2, 3, 4, 5, 6, 7, 8];
            let sum = 0;

            // Изчисляване на сбора с тегла
            for (let i = 0; i < digits.length; i++) {
                sum += digits[i] * weights[i];
            }

            let remainder = sum % 11;
            if (remainder === 10) {
                // Пресмятане с нови тегла при остатък 10
                const secondWeights = [3, 4, 5, 6, 7, 8, 9, 10];
                sum = 0;
                for (let i = 0; i < digits.length; i++) {
                    sum += digits[i] * secondWeights[i];
                }
                remainder = sum % 11;

                if (remainder === 10) {
                    remainder = 0; // Ако отново е 10, се приема 0
                }
            }

            return remainder;
        };

        // Валидиране на 9-цифрен Булстат
        if (digits.length === 9) {
            const baseNumber = digits.slice(0, 8);
            const checksum = digits[8];
            const calcChecksum = validateChecksum(baseNumber);
            if (calcChecksum === checksum) {
                return true; // Валиден
            }
            return terms.validation_format_bulstat; // Невалиден
        }

        // Валидиране на 13-цифрен Булстат
        if (digits.length === 13) {
            const baseNumber = digits.slice(0, 8);
            const checksum1 = digits[8];

            // Проверява първите 9 цифри с контролната цифра
            const calcChecksum = validateChecksum(baseNumber);
            if (calcChecksum !== checksum1) {
                return terms.validation_format_bulstat; // Невалиден
            }

            // Последните 4 цифри не се валидират
            return true; // Валиден
        }

        return terms.validation_format_bulstat; // Ако дължината не е 9 или 13
    },

    maxCharachters: (n) => (value) => 
        typeof value !== "string" || value.length <= n || terms.validation_max_charachters.replace("$NUMBER$", n),

});
